export class PackagePresenter {
  constructor(item) {
    this.id = item.id;
    this.name = item.name;
    this.imageUrl = item.imageUrl;
  }
}


// WEBPACK FOOTER //
// ./src/presenters/group/package-group/PackagePresenter.js